import { render, staticRenderFns } from "./WaveReflectionViz.vue?vue&type=template&id=406bc26a&scoped=true"
import script from "./WaveReflectionViz.vue?vue&type=script&lang=js"
export * from "./WaveReflectionViz.vue?vue&type=script&lang=js"
import style0 from "./WaveReflectionViz.vue?vue&type=style&index=0&id=406bc26a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bc26a",
  null
  
)

export default component.exports